export const PL = {
  preparing_zip: "Przygotowywanie zip…",
  compressing: "Kompresja…",
  info_icon: "Po oznaczeniu jako ukończone, żadni dodatkowi członkowie nie mogą dołączyć ani zostać dodani, a wszystkie grupy czatu zostaną dezaktywowane. Należy pamiętać, że projekt wraz ze wszystkimi grupami czatu i danymi pozostanie dostępny w stanie dezaktywowanym.",
  mark_is_done: "Czy na pewno chcesz oznaczyć projekt jako ukończony? Po oznaczeniu żadni dodatkowi członkowie nie mogą dołączyć ani zostać dodani, a wszystkie grupy czatu zostaną dezaktywowane. Należy pamiętać, że projekt wraz ze wszystkimi grupami czatu i danymi pozostanie dostępny w stanie dezaktywowanym.",
  mark_not_done: "Czy na pewno chcesz ponownie otworzyć projekt? Po oznaczeniu jako otwarty, dodatkowi członkowie mogą dołączyć lub zostać dodani, a wszystkie grupy czatu zostaną reaktywowane.",
  mark_as_completed: "Oznacz projekt jako ukończony",
  room_completed: "Projekt ukończony",
  room_members: "Członkowie projektu",
  deactivated_rooms: "Dezaktywowane projekty",
  deactivated_chats: "Dezaktywowane czaty",
  completed_rooms: "Ukończone projekty",
  request_to_join_a_room: 'Prośba o dołączenie do projektu',
  wants_to_rejoin_room: 'Username chce ponownie dołączyć do projektu Roomname.',
  invited_you_to_join_room: 'Username zaprosił Cię do dołączenia do projektu Roomname.',
  restart: "Uruchom ponownie",
  update_text: "Dostępna jest nowa aktualizacja. Kliknij uruchom ponownie, aby zainstalować aktualizację.",
  update_availble: "Dostępna aktualizacja",
  Loading: "Ładowanie...",
  logout: "Wyloguj",
  back: 'Wstecz',
  company_list: "Lista firm",
  followers: "Obserwujący",
  followings: "Obserwowani",
  article: "Artykuł",
  companies: "Firmy",
  one_to_one_chat: " Czat jeden na jeden",
  profile: "Profil",
  company: "Firma",
  company_selection: "Wybór firmy",
  home: "Strona główna",
  contact: "Kontakt ",
  add_company: "Dodaj firmę ",
  add_project: "Dodaj projekt ",
  capacities: "Możliwości ",
  work_area: "Obszar pracy",
  company_services: "Usługi firmy",
  website: "Strona internetowa",
  search_contacts: "Szukaj kontaktów",
  add_or_join_a_company: "Dodaj lub dołącz do firmy",
  follow: "Obserwuj",
  following: "Obserwowanie",
  like: "Polub",
  company_contacts: "Kontakt firmy",
  leave_the_company: "Opuść firmę",
  news: "Aktualności",
  earlier: "Wcześniej",
  action: "Akcja",
  another_action: "Inna akcja",
  something_else: "Coś innego",
  search: "Szukaj",
  search_rooms: "Szukaj projektów",
  search_articles: "Szukaj artykułów",
  contacts: "Kontakty",
  suggestions: "Sugestie",
  project_list: "Lista projektów",
  search_results: "Wyniki wyszukiwania",
  add_or_join_project: "Dodaj lub dołącz do projektu",
  details: "Szczegóły",
  your_position_within_company:
    "Proszę wybrać swoją pozycję w firmie.",
  close_modal: "Zamknij",
  map: "Mapa",
  or: "Lub",
  name: "Nazwa*",
  street: "Ulica*",
  house_number: "Numer domu",
  postal_code: "Kod pocztowy",
  city: "Miasto*",
  opened_by: "Otwarte przez:",
  project_No: "Numer projektu: ",
  building_type: "Typ budynku*",
  building_types: "Typ budynku",
  add_join: "Dodaj/Dołącz",
  mandatory_fiels: "*pola obowiązkowe",
  invalid_fiels: "To pole jest wymagane",
  add_or_join_company: "Dodaj lub dołącz do firmy",
  name_of_the_company: "Nazwa firmy",
  edit_company_details: "Edytuj szczegóły firmy",
  branch_of_the_building_industry: "Dział branży budowlanej",
  corporate_form: "Forma prawna",
  position_within_company: "Pozycja w firmie",
  request_confirmation: "Oczekujące prośby o projekty",
  company_e_mail: "E-mail firmy",
  type_of_filter: "Wpisz, aby filtrować...",
  setting: "Ustawienie",
  dashboard: "Panel",
  settings: "Ustawienia",
  views: "Wyświetlenia",
  times_seen: "razy wyświetlone",
  see_more: "...więcej",
  see_less: "...mniej",
  in_search: "w wyszukiwaniu",
  reset_password: "Resetuj hasło",
  submit: "Wyślij",
  password: "Hasło",
  email: "E-mail",
  confirm_password: "Potwierdź hasło",
  reset_email: "Resetuj e-mail",
  update: "Aktualizuj",
  new_email: "Nowy e-mail",
  kjuup_message: "Wiadomość Kjuup",
  delete_profile: "Usunąć profil?",
  my_position: "Moja pozycja:",
  add: "dodaj",
  owner_company_admin: "Administrator firmy :",
  owner_company_admin_new: "Administrator firmy",
  mutual_contact: "wspólny kontakt",
  mutual_contacts: "wspólne kontakty",
  co_owner: "Współwłaściciel",
  managing_director: "Dyrektor zarządzający",
  associate: "Wspólnik",
  secretary: "Sekretarz",
  employee: "Pracownik",
  project_manage: "Kierownik projektu",
  auto_chat_translation: "Automatyczne tłumaczenie czatu",
  translate_room_group_names: "Tłumacz nazwy grup czatu",
  translate_room_group_names_info: "Po włączeniu nazwy grup czatu są automatycznie tłumaczone na język interfejsu.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Po włączeniu karta E-Mail będzie otwierana domyślnie zamiast Wiadomości po uruchomieniu aplikacji.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Język",
  english: "Angielski",
  german: "Niemiecki",
  french: "Francuski",
  italian: "Włoski",
  change_language: "Zmień język",
  my_companies: "Moje firmy",
  employees: "Pracownicy",
  invite_with_a: "Zaproś do Kjuup",
  add_member: "Dodaj członka",
  add_user: "Dodaj użytkownika",
  send_location: "Wyślij lokalizację",
  assign_admin_rights: "Dostosuj prawo administratora",
  deactivate_company: "Dezaktywuj firmę",
  remove_employees: "Usuń pracowników",
  remove_members: "Usuń członków",
  no_user_found: "Nie znaleziono użytkownika!",
  approve: "Zatwierdź!",
  deselect_all: "Odznacz wszystko",
  select_all: "Zaznacz wszystko",
  translation_on_building_projects: "Tłumaczenie w projektach",
  reported_capacities: "Zgłoszone usługi",
  up_to_50m_exact: "Do 50m dokładnie",
  company_details_service: "Usługi firmy",
  company_contact: "Kontakt firmy",
  invite_with_link: "Zaproś do Kjuup",
  share_link: "Udostępnij link",
  share_company_link: "Udostępnij link",
  qr_code: "Kod QR",
  copy_link: "Kopiuj link",
  cancel_link: "Anuluj link",
  who_has_confirmed_services: "Kto potwierdził twoje usługi?",
  projectss: "Projekty",
  add_services: "Dodaj usługi",
  services: "Usługi",
  save_text: "Zapisz",
  share_on: "Udostępnij na:",
  articlen: "Artykuł",
  invite_user_to_confirm_service:
    "Zaproś użytkowników do potwierdzenia usług firmy.",
  link_copied: "Link skopiowany!",
  email_copied: "E-mail skopiowany!",
  personal_article: "Artykuł osobisty",
  company_article: "Artykuł firmy",
  characters_remaining: "Pozostało znaków",
  optional_information: "Informacje opcjonalne",
  project: "Projekt",
  projects: "Projekty...",
  abort: "Odrzuć",
  preview: "Podgląd",
  post: "Opublikuj",
  of: "z",
  remove: "Usuń",
  free_capacity: "Portal pracy",
  current_status_overview: "Przegląd aktualnego statusu",
  report_capacities: "Zgłoś usługi",
  report_text: "Zgłoś",
  search_capacities: "Znajdź wykonawców",
  add_project_user: "Dodaj użytkownika projektu",
  media: "Media",
  links: "Linki",
  docs: "Dokumenty",
  featured_products: "Wyróżnione produkty...",
  title: "Tytuł",
  text: "Tekst",
  feed_details: "Szczegóły kanału",
  add_employee: "Dodaj pracownika",
  latest: "Najnowsze",
  my_projects: "Moje projekty",
  cancel: "Anuluj",
  continue: "Kontynuuj",
  role_in_the_building_industry: "Rola w branży budowlanej",
  als: "jako",
  join: "dołącz",
  find: "Znajdź",
  request_to_join_a_company: "Prośba o dołączenie do firmy",
  wants_to_join_the_company: "chce dołączyć do firmy",
  filter_by: "Filtruj według",
  ok: "Ok",
  close: "Zamknij",
  weekly_statistics: "Statystyki tygodniowe",
  is_following_you: "obserwuje cię.",
  as: "jako",
  has_joined_the: "dołączył do firmy",
  has_looked_at_your_profile: "obejrzał twój profil.",
  time: "Godzina",
  in_searches_in_past_week: "w wyszukiwaniach w minionym tygodniu.",
  has_liked_your_article: "polubił twój artykuł.",
  has_published_a_new_article: "opublikował nowy artykuł.",
  you: "Ty",
  all_views: "Wszystkie wyświetlenia",
  all_profile_views: "Wszystkie wyświetlenia profilu",
  mutual_company: "wspólna firma",
  artical_text: "Napisz artykuł...",
  you_have_appeared: "Pojawiłeś się",
  your_request_at_the_company: "Twoja prośba w firmie",
  times_you_have_appeared_in_searches: "razy pojawiłeś się w wyszukiwaniach",
  appear_more_often_in_searches: "Pojawiaj się częściej w wyszukiwaniach",
  you_have_been_found: "Zostałeś znaleziony",
  improve_profile: "Ulepsz profil",
  choose_existing_contact_for_single_chat:
    "Wybierz istniejący kontakt do czatu indywidualnego:",
  in_order_to_add_new_contacts:
    "Aby dodać nowe kontakty, wyszukaj nowe kontakty na stronie profilu.",
  times_in_searches_in_the_last_week:
    "razy w wyszukiwaniach w minionym tygodniu. Zaktualizuj swój profil i dodaj więcej szczegółów, aby być łatwiej znajdowanym.",
  has_been_confirmed: "zostało potwierdzone.",
  have_joined_the: "dołączyli do  ",
  building_project: " projektu budowlanego.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Wybierz firmę, którą będziesz reprezentować. To będzie wyświetlane innym uczestnikom.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Wybierz firmę, którą będziesz reprezentować. To będzie wyświetlane innym uczestnikom.",
  select_internal_section: "Proszę wybrać sekcję wewnętrzną",
  select_profile_image: "Wybierz obraz profilu",
  share_user: "Udostępnij użytkownika",
  contact_sender_message:
    "Udostępnij ten link, aby zaprosić nieczłonka Kjuup do Kjuup. Ten link może być używany przez wiele osób do rejestracji.",
  project_sender_message:
    "Udostępnij ten link, aby zaprosić nieczłonka Kjuup do projektu nazwa projektu. Ten link może być używany przez wiele osób do rejestracji i dołączenia do projektu nazwa projektu w Kjuup.",
  company_sender_message:
    "Udostępnij ten link, aby zaprosić nieczłonka Kjuup do firmy nazwa firmy. Ten link może być używany przez wiele osób do rejestracji i dołączenia do firmy w Kjuup.",
  contact_receivers_message:
    "Link zaproszenia do dołączenia do Kjuup. Proszę kliknąć link, aby zarejestrować się w kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "W przypadku instalowania Kjuup przez Apple App Store, musisz kliknąć ten link po udanym pobraniu, aby móc się zarejestrować.",
  project_receivers_message:
    "Link zaproszenia do dołączenia do projektu nazwa projektu w Kjuup. Proszę kliknąć link, aby zarejestrować się w Kjuup i dołączyć do projektu nazwa projektu.",
  company_receivers_message:
    "Link zaproszenia do firmy nazwa firmy w Kjuup. Proszę kliknąć link, aby zarejestrować się w Kjuup i dołączyć do firmy nazwa firmy.",
  sign_in: "Zaloguj się",
  enter_your_email_add: "Wprowadź swój adres e-mail",
  forgot_password: "Zapomniałeś hasła?",
  dont_have_account: "Nie masz konta?",
  register: "Zarejestruj się",
  get_app: "Pobierz aplikację",
  registration: "Rejestracja",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architekt",
  prof: "Prof.",
  first_name: "Imię",
  last_name: "Nazwisko",
  have_an_account: "Masz konto?",
  when_register_you_agree: "Rejestrując się, zgadzasz się z naszymi",
  term_of_use: "warunkami użytkowania",
  to: "do.",
  in_our: "W naszej",
  data_policy: "polityce danych",
  they_find_out: "dowiadują się,",
  we_provide_store_data: "jak zbieramy, przetwarzamy i przechowujemy informacje.",
  leaving_company_text:
    "Czy naprawdę chcesz opuścić firmę? Opuszczając firmę, opuszczasz również wszystkie powiązane projekty i grupy czatu. Możesz ponownie dołączyć do tych projektów z inną firmą w dowolnym momencie.",
  delete_profile_text:
    "Czy naprawdę chcesz usunąć swój profil? Gdy usuniesz swój profil, wszystkie połączenia z firmami, projektami i czatami zostaną usunięte. Możesz utworzyć nowy profil w dowolnym momencie.",
  confirm: "Potwierdź",
  reject: "Odrzuć",
  requet_to_leave: "Prośba o opuszczenie",
  choose: "Wybierz",
  your_add_member: "Dodaj członka",
  if_you: "w przypadku, gdy",
  can_not_find: "nie możesz znaleźć swojego kontaktu tutaj.",
  please_wait: "Proszę czekać..",
  imprint_gtc: "Imprint/Warunki użytkowania",
  register_confirm_popup: "Potwierdź adres e-mail Kjuup przed zalogowaniem. Wysłaliśmy link potwierdzający. Jeśli go nie widzisz, sprawdź folder spam.",
  PENDING_GROUP_USER:
    "będzie otrzymywać wiadomości dopiero po potwierdzeniu zaproszenia do projektu. Dodatkowa wiadomość pojawi się po potwierdzeniu zaproszenia do projektu.",
  PENDING: "Potwierdzenie zaproszenia do projektu oczekuje",
  denied_group_chat: " odrzucił zaproszenie do projektu i opuścił tę grupę.",
  // joined_group_chat: " dołączył do pokoju i tej grupy.",
  joined_group_chat: " dołączył do tej grupy",
  you_joined_group_chat: "Dołączyłeś do tej grupy.",
  Others: "Inni",
  LEFT_GROUP: "opuścił tę grupę czatu.",
  YOU_LEFT_GROUP: "opuścili tę grupę czatu.",
  days: "dni",
  day: "dzień",
  hour: "godzina",
  hide_project: "Ukryj projekt",
  hide_project_popup_text:
    "Jeśli ukryjesz projekty, nie można ich znaleźć w Kjuup. Tylko członkowie projektu mogą zapraszać nowych użytkowników do projektu.",
  branch: "Dział",
  photo_video_media_lib: "Biblioteka mediów - Zdjęcia i wideo",
  document: "Dokument",
  location_meeting: "Lokalizacja / Spotkanie",
  all_member_of_project: "Wszyscy członkowie projektu",
  pending_request: "Oczekujące prośby o projekty",
  no_pending_request: "Nie znaleziono oczekujących próśb!",
  news_feed: "Kanał aktualności",
  user_info: "Informacje o grupie",
  leave_project: "Opuść projekt",
  media_link_docs: "Pliki",
  search_chat: "Szukaj w czacie",
  export_chat_group: "Eksportuj dane grupy czatu z ostatniego miesiąca",
  request_complete_chat_history: "Poproś o pełną historię czatu",
  leave_chat_group: "Opuść grupę czatu",
  add_user_project: "Dodaj użytkownika",
  me: "Ja",
  max_open_one_to_one:
    "Obecnie maks. 2 czaty jeden na jeden mogą być otwarte równolegle w sekcji dolnej i górnej. W sumie maks. 4 czaty jeden na jeden są możliwe.",
  are_you_sure_you_want_leave_chat:
    "Czy na pewno chcesz opuścić tę grupę czatu?",
  create_group: "Utwórz grupę",
  adding_members: "Dodawanie członków...",
  creating_the_chat: "Tworzenie czatu...",
  finishing_setup: "Finalizowanie...",
  group_name: "Nazwa grupy",
  by: "Przez:",
  mandetory: "*obowiązkowe",
  delteed: "usunął(ła) swój profil i opuścił(ła) grupowy czat.",
  deleted_direct: "usunął(ła) swój profil i opuścił(ła) czat.",
  unhidden_message:
    "Jeśli pokażesz projekty, mogą być znalezione przez wszystkich członków Kjuup.",
  account_deleted: "Konto zostało usunięte.",
  refuse_company: "Czy na pewno chcesz odrzucić zaproszenie firmy?",
  follow_additional: "Obserwuj dodatkowych użytkowników",
  f_add:
    "Obserwuj dodatkowych użytkowników Kjuup, aby uczynić ich dostępnymi do bezpośrednich wiadomości.",
  c_inv: "Zaproszenie(enia) firmy",
  invited_o_Company: "Zostałeś zaproszony do dołączenia do firmy",
  refuse_companyX: "Czy na pewno chcesz odrzucić prośbę firmy?",
  a_Da: "Konto dezaktywowane.",
  has_deactivated: "dezaktywował(ła) swój profil.",
  reactive: "reaktywował(ła) swój profil.",
  juup_note: "*Rejestracja z nazwą użytkownika dostępna tylko dla członków Kjuup+",
  username: "Nazwa użytkownika*",
  email_username: "E-mail/Nazwa użytkownika*",
  sPinText:
    "Proszę podać 6-cyfrowy PIN bezpieczeństwa. Ten PIN będzie potrzebny w przypadku zapomnienia hasła i jest obowiązkowy do potwierdzenia konta.",
  DeleteKjuupPlusText:
    "Czy naprawdę chcesz usunąć swój profil? Gdy usuniesz swój profil, wszystkie połączenia z firmami, projektami i czatami zostaną usunięte.\n\nW ciągu 48 godzin po usunięciu konta możesz reaktywować swoje konto, logując się z nazwą użytkownika, hasłem i PIN-em.",
  reactive_text:
    "Twoje konto zostało usunięte. Proszę kliknąć Reaktywuj, aby reaktywować swoje konto.",
  rac: "Reaktywuj",
  ac_ss: "Konto zostało pomyślnie reaktywowane.",
  not_valid_pin: "PIN nieprawidłowy",
  only_for_kjuup:
    "*Reset hasła przez nazwę użytkownika i PIN dostępny tylko dla członków Kjuup+.",
  resetPIN: "Resetuj PIN",
  enter_current_pin: "Proszę wprowadzić swój aktualny PIN",
  enter_new: "Wprowadź nowy PIN",
  pin_to_confirm: "Proszę podać PIN do potwierdzenia.",
  change_username: "Resetuj nazwę użytkownika",
  pp_not_match: "Hasło i potwierdzenie hasła nie pasują",
  reactive_itself: "Zareaktywowałeś swój profil.",
  has_deactivated_itself: "Dezaktywowałeś swój profil.",
  more_than_two:
    "Obecnie wiadomości bezpośrednie mogą być wysyłane tylko do 2 użytkowników równolegle.",
  Chats: "Wiadomości bezpośrednie",
  only_in_mobileL:
    "Natywne wideo mogą być obecnie przesyłane i publikowane tylko przez aplikację mobilną. Proszę używać linków wideo z Youtube i Vimeo.",
  register_pin_text:
    "Proszę wybrać swój osobisty 6-cyfrowy PIN. Ten PIN będzie potrzebny do włączenia funkcji resetowania konta.",
  internal_project: "Wewnętrzny",
  external_projects: "Zewnętrzny",
  in_deacticted: "Sekcja wewnętrzna jest dezaktywowana.",
  create_article: "Utwórz artykuł",
  new_article_selection: "Utwórz artykuł dla zewnętrznego kanału aktualności",
  new_article_selection_internal: "Utwórz wewnętrzny artykuł",
  active_trans_title: "Włączyć automatyczne tłumaczenie?",
  active_trans: "Po włączeniu wszystkie przychodzące wiadomości czatu zostaną przetłumaczone na wybrany język aplikacji.",
  disable_trans: "Czy naprawdę chcesz dezaktywować automatyczne tłumaczenie?",
  allow_access_chat: "Pokaż pełną historię czatu",
  toggle_chat_history_on:
    "Czy naprawdę chcesz, aby użytkownik widział pełną historię czatu?",
  toggle_chat_history_off:
    "Czy naprawdę chcesz, aby użytkownik widział tylko historię czatu od momentu dołączenia do czatu?",
  check_selected_settings:
    "Proszę sprawdzić ustawienia historii czatu dla wszystkich wybranych użytkowników!",
  chat_from_start_have:
    "Dołączyłeś do tej grupy. Historia czatu została udostępniona.",
  chat_from_start_has:
    "dołączył do tej grupy. Historia czatu została udostępniona.",
  Address: "Adres",
  read_by: "Przeczytane przez",
  deliver_to: "Dostarczone do",
  remaining: "pozostało",
  message_info: "Informacje o wiadomości",
  request_to_join_only: "Prośba o dołączenie",
  unfollow: "Przestań obserwować",
  company_username: "Nazwa użytkownika",
  month: [
    "Sty",
    "Lut",
    "Mar",
    "Kwi",
    "Maj",
    "Cze",
    "Lip",
    "Sie",
    "Wrz",
    "Paź",
    "Lis",
    "Gru",
  ],
  remove_my_admin_right: "Usuń moje prawa administratora",
  makeEmp: "Czy naprawdę chcesz usunąć prawa administratora firmy użytkownika?",
  remove_my_self:
    "Czy naprawdę chcesz usunąć prawa administratora firmy ze swojego konta?",
  makeAdmin: "Czy naprawdę chcesz nadać użytkownikowi prawa administratora firmy?",
  remove_member: "Usuń członka",
  remove_following_confirm: "Czy na pewno chcesz usunąć {name} z listy obserwowanych?",
  remove_follower_confirm: "Czy na pewno chcesz usunąć {name} z obserwujących Cię? Jeśli go/ją usuniesz, nie zostanie poinformowany/a.",
  do_you_really_want_to_remove:
    "Czy naprawdę chcesz usunąć nazwę użytkownika z firmy?",
  invite_all: "Zaproś wszystkich członków firmy",
  invite_all_members: "Zaproś wszystkich członków",
  mems: "Wszyscy inni członkowie",
  dep_loc: "Dział/Lokalizacja/Zespół",
  depAdmin: "Administrator działu",
  add_remove_admin: "Dodaj/Usuń pozycję administratora firmy",
  add_remove_dep_admin: "Dodaj/Usuń pozycję administratora działu",
  remove_employees_dept: "Usuń pracowników z",
  want_to_join_dep:
    "Nazwa użytkownika chce dołączyć do Działu/Lokalizacji/Zespołu depname firmy companyname.",
  you_invited:
    "Zostałeś zaproszony do dołączenia do Działu/Lokalizacji/Zespołu depname firmy companyname.",
  dep_remove:
    "Czy naprawdę chcesz usunąć prawa administratora działu lub lokalizacji użytkownika?",
  add_dep:
    "Czy naprawdę chcesz nadać użytkownikowi prawa administratora dla działu lub lokalizacji?",
  my_self_dep_remove:
    "Czy naprawdę chcesz usunąć prawa administratora działu ze swojego konta?",
  member: "Członek",
  admin: "Administrator",
  remove_project_admin:
    "Czy naprawdę chcesz usunąć członka z projektu?",
  remove_my_self_project: "Czy naprawdę chcesz usunąć prawa administratora?",
  remove_member_admin_right:
    "Czy naprawdę chcesz usunąć prawa administratora użytkownika?",
  add_member_admin_right: "Czy naprawdę chcesz dodać prawa administratora użytkownikowi?",
  add_remove_Poss: "Dodaj/Usuń pozycję administratora",
  forward: "Przekaż dalej",
  forward_to: "Przekaż do...",
  edit: "Edytuj",
  only_kjuup_plus_can: "Tylko firmy Kjuup+ mogą publikować artykuły.",
  add_images: "Dodaj obraz(y)",
  request_confirmation: 'Oczekujące zaproszenia do projektów',
  Activity: "Aktywność",
  latest_messages: "Najnowsze wiadomości",
  hours: "godzin",
  minute: "minut",
  seconds: "sekund",
  days: "dni",
  yesterday: "wczoraj",
  last_week: "w zeszłym tygodniu",
  next_week: "w przyszłym tygodniu",
  Last_month: "w zeszłym miesiącu",
  All: "Wszystko",
  register_plus: "Rejestracja Plus",
  select_files: "Wybierz pliki",
  monthsFullName: [
    "Styczeń",
    "Luty",
    "Marzec",
    "Kwiecień",
    "Maj",
    "Czerwiec",
    "Lipiec",
    "Sierpień",
    "Wrzesień",
    "Październik",
    "Listopad",
    "Grudzień",
  ],
  company_deploc_receivers_message:
    "Link zaproszenia do działu firmy nazwa firmy w Kjuup. Proszę kliknąć link, aby zarejestrować się w Kjuup i dołączyć do firmy nazwa firmy.",
  no_news: "Brak dostępnych aktualności",
  reminder: "Przypomnienie",
  np_reminder: "Brak zadań",
  move_to_reminder: "Przenieś do zadania",
  remove_reminder: "Czy naprawdę chcesz usunąć tę wiadomość z listy swoich zadań?",
  remove_all_reminder: "Usuń wszystkie zadania",
  remove_all_confirm: "Czy naprawdę chcesz usunąć wszystkie wiadomości z listy swoich zadań?",
  remove_from_reminder: "Usuń z przypomnienia",
  prevent_email: "E-mail nie może być używany jako nazwa użytkownika.",
  allow_noti: "Proszę zezwolić na powiadomienia.",
  join_cap: "Dołącz",
  pass_minimum:
    "**Hasło wymaga 12 znaków, w tym małą literę, wielką literę, cyfrę i znak specjalny.",
  pass_error: "Proszę sprawdzić wymagania dotyczące hasła",
  people_that_like_article: "Ludzie, którym podoba się artykuł.",
  people_who_like_article: "Ludzie, którym podoba się twój artykuł.",
  message_delete: "Ta wiadomość została usunięta.",
  message_edited: "edytowano",
  edit_message: "Edytuj wiadomość",
  edit_window_expired: "Wiadomości można edytować tylko w ciągu 10 minut od wysłania.",
  message_edit_save: "Zapisz",
  copy: "Kopiuj",
  bookmark: "Zakładka",
  add_reaction: "Dodaj reakcję",
  delete_message: "Usuń wiadomość",
  more_options: "Więcej opcji",
  info: "Info",
  link_invite: "Zaproś przez link",
  ll_nkk: "Zaproś do Kjuup",
  selected: "Wybrane",
  is_active: "Aktywne",
  inactive: "Nieaktywne",
  last_online: "ostatnio online {{when}}",
  remove_user_l: "Usuń",
  link_expire: "Każdy wygenerowany link będzie ważny przez 72 godziny.",
  company_language: "Język firmy",
  company_language_info:
    "Wybór języka będzie używany do wszystkich potwierdzeń e-mail dotyczących firmy.",
  s_image: "obraz",
  m_image: "obrazy",
  removeMsg: "Dotknij, aby usunąć",
  block: 'Zablokuj',
  unblock: 'Odblokuj',
  blocks: 'Czy na pewno chcesz zablokować tego użytkownika?',
  unblocks: 'Czy na pewno chcesz odblokować tego użytkownika?',
  bolcked_click_un_block:
    'Zablokowałeś ten kontakt. Kliknij tutaj, aby usunąć blokadę.',
  you_have_unblocked: 'Odblokowałeś ten kontakt.',
  you_have_blocked: 'Zablokowałeś ten kontakt.',
  unblock_to_send: 'Odblokuj użytkownika, aby wysłać wiadomość.',
  pilot_text: "Wyspecjalizowana AI dla tematów budowlanych",
  startup_screen_label: "Ekran startowy",
  startup_screen_info: "Wybierz, który ekran otwiera się przy starcie Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Wiadomości",
  startup_screen_saved: "Ekran startowy zaktualizowany",
email_on: "Powiadomienia e-mail czatów",
  email_on_grp: "Powiadomienie e-mail",
  article_email_on: "Powiadomienia e-mail artykułów",
  article_email_info: "Jeśli włączysz powiadomienia e-mail o artykułach wewnętrznych, otrzymasz e-mail, gdy w Twojej firmie i dziale zostanie opublikowany nowy artykuł wewnętrzny.",
  info_email_room: "Aktywuj lub dezaktywuj powiadomienia e-mail dla tego projektu. Ta opcja jest dostępna tylko wtedy, gdy \"Powiadomienia e-mail czatów\" jest włączone przez ustawienia osobiste.",
  todo_notification_info: "Otrzymasz powiadomienie za każdym razem, gdy zostanie Ci przypisane nowe zadanie.",
  info_val: "Otrzymasz e-mail, jeśli nowa wiadomość na czacie nie zostanie przeczytana w krótkim czasie. Możesz to wyłączyć dla poszczególnych projektów lub czatów w ich ustawieniach lub w informacjach grupy czatu.",
  email_groups: "Aktywuj lub dezaktywuj powiadomienia e-mail dla tego czatu. Ta opcja jest dostępna tylko wtedy, gdy \"Powiadomienia e-mail czatów\" jest włączone przez ustawienia osobiste i projektu.",
  add_update_email: "Dodaj/Aktualizuj e-mail",
  text_to_verifiy: "Opcja \"Powiadomienia e-mail czatów\" może być włączona tylko wtedy, gdy masz zweryfikowany adres e-mail w pliku.",
  stored_email: "Zapisany e-mail: ",
  verify_email: "Potwierdzenie oczekuje!",
  join_call:"Dołącz",
  call_is_started:"Połączenie rozpoczęte",
  start_chat:"Rozpocznij czat bezpośredni?",
  project_rooms:"Projekty",
  download_selected:"Pobierz",
  add_employee_confirm: 'Czy na pewno chcesz dodać tego użytkownika do firmy?',
  invalid_deeplink: "Nieprawidłowy URL głębokiego linku. Brakuje wymaganych parametrów.",
  deeplink_error: "Nie można przetworzyć głębokiego linku. Proszę spróbować ponownie później.",
  // Reply functionality translations
  reply: "Odpowiedz",
  reply_enter: "Wprowadź odpowiedź...",
  reply_sent_successfully: "Odpowiedź wysłana pomyślnie",
  reply_failed: "Nie udało się wysłać odpowiedzi",
  reply_failed_generic: "Nie udało się wysłać odpowiedzi. Proszę spróbować ponownie.",
  replying_to_message: "Odpowiadanie na wiadomość",
  cancel_reply: "Anuluj odpowiedź",
  voice_message: "Wiadomość głosowa",
  send: "Wyślij",
  cancel: "Anuluj",
  type_your_reply: "Wpisz swoją odpowiedź...",
  
  // Auto-suggestion translations
  suggested_replies: "Sugerowane odpowiedzi",
  suggestions_error: "Nie udało się załadować sugestii",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Obraz — Kliknij, aby załadować",
  lazy_media_audio: "Wiadomość głosowa — Kliknij, aby załadować",
  lazy_media_doc: "Dokument — Kliknij, aby załadować",
  lazy_media_video: "Wideo — Kliknij, aby załadować",
  suggestion_loading_message: "Chwila. Twój tekst jest przygotowywany indywidualnie dla ciebie.",
  loading_chat_message: "Ładowanie czatu...",
  
  // Manual ToDo translations
  extracting_message: "Wyodrębnianie wiadomości...",
  create_todo: "Utwórz zadanie",
  create_todo_confirmation: "Czy chcesz utworzyć zadanie z tej wiadomości?",
  select_project_required: "Proszę wybrać projekt/grupę",
  only_assigned_can_change_status: "Tylko przypisani użytkownicy mogą zmieniać status",
  todo_summary: "Podsumowanie",
  todo_summary_placeholder: "Wprowadź podsumowanie zadania...",
  todo_date: "Data",
  todo_time: "Godzina",
  todo_date_hint: "Pozostaw puste, aby użyć daty/godziny oryginalnej wiadomości",
  todo_created_success: "Zadanie utworzone pomyślnie",
  todo_creation_failed: "Nie udało się utworzyć zadania",
  create: "Utwórz",
  
  image: "obraz",
  images: "obrazy",
  remove_all_images: "Usuń wszystkie obrazy",
  remove_image: "Usuń obraz",
  remove_document: "Usuń dokument",
  remove_recording: "Usuń nagranie",
  play_recording: "Odtwórz nagranie",
  upload_image: "Prześlij obraz",
  upload_document: "Prześlij dokument",
  record_audio: "Nagraj audio",
  stop_recording: "Zatrzymaj nagranie",
  stop_recording_text: "Zatrzymaj nagranie",
  please_remove_current_attachment: "Proszę usunąć bieżące załącznik, aby",
  please_upload_image_file: "Proszę przesłać prawidłowy plik obrazu",
  please_upload_valid_document: "Proszę przesłać prawidłowy plik dokumentu",
  searching_messages: "Wyszukiwanie wiadomości...",
  loading_more: "Ładowanie więcej...",
  loading_more_users: "Ładowanie więcej użytkowników...",
  load_more_users: "Załaduj więcej użytkowników",
  no_more_users_to_load: "Brak więcej użytkowników do załadowania",
  no_messages_found: "Nie znaleziono wiadomości",
  try_different_keyword: "Spróbuj innego słowa kluczowego lub sprawdź pisownię.",
  search_messages: "Szukaj wiadomości, grup czatu, sal projektowych i użytkowników...",
  todo: "Zadanie",
  np_todo: "Brak zadań",
  move_to_todo: "Zapisz jako zadanie",
  remove_todo: "Czy naprawdę chcesz usunąć zadanie?",
  remove_all_todo: "Usuń wszystkie zadania",
  remove_all_todo_confirm: "Czy naprawdę chcesz usunąć wszystkie zadania?",
  add_to_todo: "Dodaj do zadania",
  remove_from_todo: "Usuń z zadania",
  confirm: "Potwierdź",
  ok: "Ok",
  read_more: "Czytaj więcej",
  show_less: "Pokaż mniej",
  show_more: "Pokaż więcej",
  audio: "Audio",
  video: "Wideo",
  // Notification Settings
  notification_schedule: "Harmonogram powiadomień",
  notification_schedule_desc: "Będziesz otrzymywać powiadomienia push i e-mail tylko w wybranych godzinach. Poza tymi godzinami będą wstrzymane.",
  learn_more: "Dowiedz się więcej",
  allow_notifications: "Zezwól na powiadomienia:",
  every_day: "Każdego dnia",
  weekdays: "Dni robocze (poniedziałek - piątek)",
  custom: "Niestandardowy",
  monday: "Poniedziałek",
  tuesday: "Wtorek",
  wednesday: "Środa",
  thursday: "Czwartek",
  friday: "Piątek",
  saturday: "Sobota",
  sunday: "Niedziela",
  to: "do",
  notification_settings: "Powiadomienia",
  notification_settings_saved: "Ustawienia powiadomień zapisane pomyślnie",
  notification_settings_error: "Nie udało się zapisać ustawień powiadomień",
  unavailability_note: "Notatka o nieobecności",
  unavailability_description: "Ustaw notatkę o nieobecności. Gdy jest aktywna, notatka jest wyświetlana innym we wszystkich czatach, a powiadomienia są wstrzymane.",
  unavailability_start_date: "Data rozpoczęcia",
  unavailability_end_date: "Data zakończenia",
  unavailability_message: "Wiadomość",
  unavailability_message_hint: "Użyj {endDate} jako symbolu zastępczego daty powrotu.",
  unavailability_replacement: "Kontakt zastępczy",
  unavailability_replacement_placeholder: "Wprowadź ID użytkownika dla pilnych spraw",
  unavailability_replacement_current: "Aktualny zastępca",
  unavailability_replacement_hint: "Jeśli ustawiono, link do kontaktu z tą osobą w pilnych sprawach zostanie wyświetlony w notatce o nieobecności.",
  unavailability_replacement_none: "Brak zastępcy (opcjonalnie)",
  unavailability_contact_urgent: "W pilnych sprawach skontaktuj się z",
  unavailability_default_message: "Obecnie jestem poza biurem i nie mam dostępu do Kjuup. Będę ponownie dostępny/a od {endDate} i wtedy się z Państwem skontaktuję.",
  unavailability_save: "Zapisz",
  unavailability_deactivate: "Dezaktywuj",
  unavailability_active_until: "Aktywne do",
  unavailability_saved: "Notatka o nieobecności zapisana",
  unavailability_save_error: "Błąd zapisu notatki o nieobecności",
  unavailability_deactivated: "Notatka o nieobecności dezaktywowana",
  unavailability_end_date_required: "Data zakończenia jest wymagana",
  start_time_before_end_time: "Godzina rozpoczęcia musi być wcześniejsza niż godzina zakończenia",
  loading: "Ładowanie",
  disabled: "Wyłączone",
  enable: "Włącz",
  disable: "Wyłącz",
  forwarded: "Przekazane dalej",
  message_forwarded: "Wiadomość przekazana dalej!",
  // Schedule Article
  schedule_article_post: "Zaplanuj publikację artykułu",
  date: "Data",
  time: "Godzina",
  scheduled_for_publication: "Zaplanowane do publikacji",
  article_will_be_published_on: "Artykuł zostanie opublikowany:",
  reset_selection: "Resetuj wybór",
  continue: "Kontynuuj",
  cancel: "Anuluj",
  // Member Selection
  error_loading_members: "Błąd ładowania członków",
  please_fill_all_fields: "Proszę wypełnić wszystkie pola",
  invalid_email: "Nieprawidłowy adres e-mail",
  member_added_successfully: "Członek dodany pomyślnie",
  error_onboarding_user: "Błąd dodawania użytkownika",
  error_creating_chat: "Błąd tworzenia czatu",
  error_creating_group: "Błąd tworzenia grupy",
  new_group: "Nowa grupa",
  please_select_or_enter_group_name: "Proszę wybrać grupę lub wprowadzić nazwę grupy",
  please_select_or_enter_room_name: "Proszę wybrać projekt lub wprowadzić nazwę projektu",
  error_creating_room: "Błąd tworzenia projektu",
  error_opening_chat: "Błąd otwierania czatu",
  privacy_modal_text: "Wybierz \"Prywatny\" tylko jeśli czat nie zawiera istotnej treści zawodowej dla kierownika projektu.",
  not_private: "Nie prywatny",
  private: "Prywatny",
  error_loading_groups: "Błąd ładowania grup",
  automatic_chat_export: "Automatyczny eksport czatu",
  automatic_chat_export_info: "Po aktywacji historia czatu będzie automatycznie wysyłana na podany adres e-mail każdego miesiąca.",
  automatic_chat_export_no_email: "Aby włączyć automatyczny eksport czatu, musisz najpierw dodać adres e-mail. Możesz dodać swój adres e-mail w ustawieniach osobistych.",
  enter_email: "Wprowadź e-mail",
  update: "Aktualizuj",
  confirm: "Potwierdź",
  export_to_email: "Eksport trafia do następującego e-maila.",
  start_chat_button:"Nowa wiadomość",
  matching_existing_chats: "Dopasowujące istniejące czaty",
  subject: "Temat",
  add_subject: "Dodaj temat",
  chat_subject: "Temat czatu:",
  set_project_room: "Ustaw projekt",
  matching_existing_project_rooms: "Dopasowujące istniejące projekty",
  name_project_room: "Nazwij projekt",
  professional_or_private: "Profesjonalny lub prywatny",
  professional: "Profesjonalny",
  privacy_modal_text_updated: "Wybierz \"Prywatny\" tylko jeśli czat nie zawiera istotnej treści zawodowej dla kierowników projektu. Prywatne czaty nie są widoczne dla kierowników projektu.",
  create_internal_chat: "Czat zewnętrzny czy wewnętrzny?",
  internal_chat_description: "Tylko pracownicy twojej firmy mogą być dodani do wewnętrznych czatów.",
  yes: "Tak",
  no: "Nie",
  chat_is_being_created: "Czat jest tworzony...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Czy na pewno chcesz odrzucić zmiany w tym artykule?",
  please_enter_article_title: "Proszę najpierw wprowadzić tytuł artykułu.",
  please_add_mandatory_fields: "Proszę dodać wszystkie pola obowiązkowe",
  product_label: "Produkt:",
  no_companies_found: "Nie znaleziono firm",
  visible_to_all_followers: "Widoczne dla wszystkich członków Kjuup",
  only_visible_to_employees: "Widoczne tylko dla pracowników",
  something_went_wrong: "Coś poszło nie tak, proszę spróbować ponownie",
  please_select_department: "Proszę wybrać dział/lokalizację",
  schedule: "Zaplanuj",
  please_select_future_date_time: "Proszę wybrać przyszłą datę i godzinę do zaplanowania artykułu.",
  please_select_different_date_time: "Proszę wybrać inną datę lub godzinę do zaplanowania artykułu.",
  please_select_later_time: "Proszę wybrać godzinę późniejszą niż aktualna dla dzisiaj.",
  unpin_article: "Odepnij artykuł",
  pin_article: "Przypnij artykuł",
  and: "i",
  others: "inni",
  at: "w",
  // Chat mute/unmute translations
  mute: "Wycisz",
  unmute: "Włącz dźwięk",
  chat_muted_successfully: "Czat wyciszony pomyślnie",
  chat_unmuted_successfully: "Dźwięk czatu włączony pomyślnie",
  mute_chat_confirm: "Czy naprawdę chcesz wyciszyć ten czat? Nie będziesz już otrzymywać powiadomień o nowych wiadomościach.",
  unmute_chat_confirm: "Czy naprawdę chcesz włączyć dźwięk tego czatu? Znowu będziesz otrzymywać powiadomienia o nowych wiadomościach.",
  please_select_group_to_forward: "Proszę wybrać grupę do przekazania wiadomości",
  // Company translations
  record_not_found: "Rekord nie znaleziony!",
  please_select_position: "Proszę wybrać pozycję",
  delete_article_confirm: "Czy na pewno chcesz usunąć ten artykuł?",
  delete_company_service_confirm: "Czy na pewno chcesz usunąć usługę firmy?",
  block_translation_confirm: "Czy naprawdę chcesz zablokować automatyczne tłumaczenie w projektach dla wszystkich członków firmy",
  unblock_translation_confirm: "Czy naprawdę chcesz odblokować automatyczne tłumaczenie w projektach dla wszystkich członków firmy",
  please_select_file: "Proszę wybrać plik do przesłania",
  role_in_building_industry: "Rola w branży budowlanej*",
  invalid_email_address: "Nieprawidłowy adres e-mail",
  please_enter_password: "Proszę wprowadzić hasło",
  password_change_email_sent: "Wiadomość e-mail została wysłana na Twój adres e-mail Kjuup. Potwierdź nowe hasło, klikając link potwierdzający w e-mailu.",
  please_enter_username: "Proszę wprowadzić nazwę użytkownika",
  username_same_as_before: "Nazwa użytkownika nie może być taka sama jak wcześniej",
  profile_deleted_successfully: "Profil usunięty pomyślnie",
  hardware_requirements: "Wymagania sprzętowe",
  hardware_requirements_list: "• 4GB RAM<br/>• Szybkość procesora min. 2GHz<br/>• Windows 7 lub wyższy / wszystkie wersje macOS",
  submitting: "Przesyłanie...",
  signing_in: "Logowanie...",
  please_enter_service_name: "Proszę wprowadzić nazwę usługi",
  something_went_wrong_error: "Aaaah! Coś poszło nie tak...",
  something_went_wrong_try_again: "Przepraszam, coś poszło nie tak. Spróbuj ponownie",
  position_label: "Pozycja:",
  loading_room: "Ładowanie projektu...",
  navigating_to_room: "Nawigowanie do projektu",
  loading_chat: "Ładowanie czatu...",
  translate: "Tłumacz",
  show_original: "Pokaż oryginał",
  saving: "Zapisywanie...",
  language_selection_info: "Wybór języka jest używany do wszystkich potwierdzeń e-mail związanych z firmą.",
  // Navigation bar labels
  nav_call: "Zadzwoń",
  nav_home: "Strona główna",
  nav_messages: "Wiadomości",
  nav_todo: "Zadania",
  nav_rooms: "Projekty",
  nav_all_rooms: "Wszystkie projekty",
  pinned_rooms_max: "Możesz przypiąć maksymalnie 10 projektów.",
  pinned_room_unpin: "Odepnij",
  pinned_rooms_drop: "Przeciągnij projekt tutaj, aby szybko go wybrać",
  nav_profile: "Profil",
  nav_company: "Firma",
  nav_company_documents: "Dokumenty",
  nav_logout: "Wyloguj",
  // Create message dialog
  add_member_title: "Dodaj członka",
  continue_btn: "Kontynuuj",
  search_placeholder: "Szukaj",
  no_members_found: "Nie znaleziono członków",
  no_groups_found: "Nie znaleziono grup",
  no_rooms_found: "Nie znaleziono projektów",
  search_users_tab: "Użytkownicy",
  search_documents_tab: "Dokumenty",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Brak plików",
  no_documents_available: "No documents",
  searching_users: "Wyszukiwanie użytkowników...",
  no_users_found: "Nie znaleziono użytkowników",
  search_emails_tab: "E-mail",
  searching_emails: "Wyszukiwanie e-maili...",
  no_emails_found: "Nie znaleziono e-maili",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Grupa bez nazwy",
  unnamed_room: "Projekt bez nazwy",
  all_members: "Wszyscy",
  room_label: "Projekt:",
  subject_label: "Temat:",
  no_members: "Brak członków",
  // Loading states for room creation
  creating_structure: "Tworzenie twojej struktury",
  opening_chat: "Otwieranie czatu",
  please_wait: "Proszę czekać...",
  // ToDo page translations
  loading_todo: "Ładowanie ToDo...",
  task_updated: "Zadanie zaktualizowane",
  error_updating_task: "Błąd aktualizacji zadania",
  task_deleted: "Zadanie usunięte",
  error_deleting_task: "Błąd usuwania zadania",
  delete_task_confirm: "Czy na pewno chcesz usunąć to zadanie?",
  description_label: "Opis",
  description_placeholder: "Wprowadź opis...",
  date_time_label: "Data i godzina",
  save_hint: "Ctrl+Enter, aby zapisać, Esc, aby anulować",
  edit_label: "Edytuj",
  delete_label: "Usuń",
  todo_list_title: "Zadania",
  tasks_count: "zadań",
  search_placeholder_todo: "Szukaj...",
  select_task_to_open_chat: "Wybierz zadanie, aby otworzyć czat",
  today: "Dzisiaj",
  yesterday: "Wczoraj",
  time_suffix: "", // Empty for Polish (24h format doesn't need suffix)
  from_chat: "Zadanie źródłowe",
  assigned_to: "Przypisane do",
  assign_users: "Przypisz użytkowników",
  no_users_assigned: "Brak przypisanych użytkowników",
  assign: "Przypisz",
  assign_to: "Przypisz do...",
  navigate_to_chat: "Przejdź do czatu",
  navigate_to_email: "Przejdź do wiadomości e-mail",
  show_original_message: "Pokaż źródło",
  hide_original_message: "Ukryj źródło",
  status_pending: "Oczekujące",
  status_in_progress: "W toku",
  status_completed: "Ukończone",
  status_confirmed: "Potwierdzone",
  show: "Pokaż",
  close: "Zamknij",
  log_todo_created: "ToDo utworzone",
  log_todo_confirmed: "ToDo potwierdzone",
  log_todo_deleted: "ToDo usunięte",
  log_todo_updated: "ToDo zaktualizowane",
  log_description_updated: "Opis zaktualizowany",
  log_deadline_updated: "Termin zaktualizowany",
  log_assigned_to: "Przypisano do {name}",
  log_unassigned_from: "Usunięto z {name}",
  log_assignment_added: "Dodano przypisanie: {name}",
  log_assignment_removed: "Usunięto przypisanie: {name}",
  log_status_updated: "Status zmieniony z {from} na {to}",
  log_status_changed: "Status zmieniony",
  log_status_changed_to: "Status zmieniony na {status}",
  log_changed_status_to: "Status zmieniony na:",
  log_for_user: "dla użytkownika:",
  log_user_updated_status: "Użytkownik zaktualizował status ToDo",
  log_changed_date_to: "Data zmieniona na:",
  log_changed_description_to: "Opis zmieniony na:",
  log_moved_to: "Przeniesiono do {status}",
  todo_status_updated_from: "z",
  todo_status_updated_to: "na",
  filter_pending: "Oczekujące",
  filter_confirmed: "Potwierdzone",
  my_list: "Mój dzień",
  todo_adjust_list: "Edytuj listę",
  apply: "Zastosuj",
  filter_assigned_to_me: "Moje zadania",
  filter_assigned_by_me: "Delegowane",
  todo_project_label: "Projekt:",
  assigned_users: "Przypisani użytkownicy:",
  todo_chat_label: "Czat:",
  history: "Historia",
  todo_assigned_by: "Przypisane przez:",
  todo_assigned_push: "Przypisano ToDo:",
  todo_assigned_push_empty: "Przypisano Ci nowe ToDo.",
  search_groups: "Grupy",
  search_chat_groups: "Grupy czatu",
  search_project_room: "Projekt",
  search_messages_tab: "Wiadomości",
  searching_groups: "Szukanie grup...",
  searching_rooms: "Szukanie projektów...",
  no_groups_found: "Nie znaleziono grup",
  no_rooms_found: "Nie znaleziono projektów",
  // ToDo filter translations
  todo_filters: "Filtry",
  todo_filter_by_project: "Filtruj według projektu",
  todo_status: "Status",
  todo_assignment: "Przypisanie",
  todo_filter_by_user: "Filtruj według przypisanej osoby",
  todo_active_filters: "Aktywne filtry:",
  todo_progress: "Postęp",
  todo_my_list_empty: "Twój dzień jest pusty",
  todo_my_list_empty_hint: "Kliknij przycisk powyżej, aby dodać zadania",
  create_poll: "Ankieta",
  poll_question_label: "PYTANIE",
  poll_question_placeholder: "Zadaj pytanie",
  poll_options_label: "OPCJE",
  poll_option: "Opcja",
  poll_add_option: "Dodaj opcję",
  poll_allow_multiple: "Zezwól na wiele odpowiedzi",
  poll_multiple_allowed: "Wybierz jedną lub więcej opcji",
  poll_select_option: "Wybierz jedną opcję",
  poll_view_votes: "Zobacz głosy",
  poll_vote_singular: "głos",
  poll_vote_plural: "głosy",
  poll_votes: "Wyniki głosowania",
  poll_no_votes_yet: "Brak głosów",
  transcript_step_processing: "Transkrypcja w toku...",
  ai_transcript_tab: "AI-Transkrypcja",
  ai_transcript_info: "Dostępne tylko dla wiadomości głosowych utworzonych po 09.03.2026.",
  transcript_more: "...więcej",
  transcript_less: "...mniej",
  ki_transcript_voice_message: "KI-Transkrypcja wiadomości głosowej",
  ki_image_analysis: "Analiza obrazu wspierana przez AI",
  type_message: "Wpisz wiadomość",
  email_tab_messages: "Wiadomości",
  email_tab_email: "E-mail",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Konta e-mail",
  email_connect_gmail: "Połącz Gmail",
  email_connect_outlook: "Połącz Outlook",
  email_no_accounts: "Brak połączonych kont e-mail",
  email_no_accounts_hint: "Połącz konto e-mail w ustawieniach profilu",
  email_no_messages: "Brak e-maili",
  email_from: "Od",
  email_to: "Do",
  email_subject: "Temat",
  email_disconnect: "Odłącz",
  email_disconnect_confirm: "Czy na pewno chcesz odłączyć to konto e-mail? Wszystkie zsynchronizowane wiadomości zostaną usunięte.",
  email_account_disconnected: "Konto e-mail zostało odłączone",
  email_account_disconnect_failed: "Nie udało się odłączyć konta",
  email_connecting: "Łączenie...",
  email_account_connected: "Konto połączone pomyślnie",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Przejdź do ustawień",
  email_date: "Data",
  email_reply: "Odpowiedz",
  email_forward: "Przekaż",
  email_copy_text: "Kopiuj tekst",
  email_text_copied: "Skopiowano!",
  email_text_copy_failed: "Nie udało się skopiować tekstu.",
  email_delete: "Usuń",
  email_not_spam: "To nie spam",
  email_not_spam_success: "E-mail przeniesiony do skrzynki odbiorczej.",
  email_not_spam_failed: "Nie udało się przenieść do skrzynki odbiorczej.",
  email_delete_confirm: "Czy na pewno chcesz usunąć tego e-maila?",
  email_delete_from_folder: "Czy na pewno chcesz usunąć z {folder}?",
  email_delete_permanent_from_folder:
    "Czy na pewno chcesz trwale usunąć z {folder}? Tej operacji nie można cofnąć.",
  email_save_draft_confirm: "Czy chcesz zapisać tę wiadomość jako szkic?",
  email_save_draft: "Zapisz szkic",
  email_discard: "Odrzuć",
  email_back_to_compose: "Wróć do pisania",
  email_draft_saved: "Szkic zapisany.",
  email_draft_save_failed: "Nie udało się zapisać szkicu.",
  email_loading: "Ładowanie e-maili...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Wybierz",
  email_attachment_singular: "Załącznik",
  email_attachment_plural: "Załączniki",
  email_back: "Wstecz",
  email_download: "Pobierz",
  email_close: "Zamknij",
  email_preview: "Podgląd",
  email_preview_not_available: "Podgląd niedostępny",
  email_preview_failed: "Podgląd niedostępny",
  select_attachments: "Wybierz załączniki",
  email_loading_preview: "Ładowanie podglądu...",
  email_mark_unread_failed: "e-mail(i) nie mogły zostać oznaczone jako nieprzeczytane.",
  email_delete_failed: "e-mail(i) nie mogły zostać usunięte.",
  filter_all: "Wszystkie",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Wiadomości bezpośrednie",
  my_notes: "My Space",
  filter_internal_groups: "Wewnętrzne czaty grupowe",
  filter_external_groups: "Zewnętrzne czaty grupowe",
  filter_group_chats: "Czaty grupowe",
  filter_groups_internal: "Wewnętrzne",
  filter_groups_external: "Zewnętrzne",
  filter_unread_only: "Tylko nieprzeczytane",
  room_daily_briefing_info: "Po włączeniu raport dla tego projektu jest generowany co 24 godziny o godzinie określonej w ustawieniach osobistych — ale tylko wtedy, gdy w tym okresie była aktywność.",
  email_select_all: "Zaznacz wszystko",
  email_deselect_all: "Odznacz wszystko",
  email_reply_all: "Odpowiedz wszystkim",
  email_reply_placeholder: "Wpisz odpowiedź...",
  email_forward_placeholder: "Dodaj wiadomość...",
  email_edit_draft: "Edytuj szkic",
  email_attach: "Załącz",
  email_attachment_from_original: "Z oryginalnej wiadomości",
  email_remove: "Usuń",
  email_drop_files: "Upuść pliki, aby załączyć",
  email_loading_attachments: "Ładowanie załączników...",
  email_archive: "Archiwizuj",
  mark_unread: "Oznacz jako nieprzeczytane",
  mark_read: "Oznacz jako przeczytane",
  email_all_accounts: "Wszystkie konta",
  email_error: "Błąd",
  email_delete_email_failed: "Nie udało się usunąć e-maila.",
  enter_url: "Wprowadź URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Subskrybuj teraz',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MIESIĄC ZA DARMO',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Dziś bez płatności. Dane karty kredytowej nie są wymagane przed rozpoczęciem płatnej subskrypcji.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Zarządzaj wszystkimi kontami e-mail bezpośrednio w Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI pisze odpowiedzi – Ty tylko potwierdzasz',
  kjuup_io_feature_tasks: 'Zadania i kalendarz zawsze automatycznie aktualne',
  kjuup_io_choose_plan: 'Wybierz plan',
  kjuup_io_plan_monthly: 'Miesięczny',
  kjuup_io_plan_yearly: 'Roczny',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Chronione przez Stripe · anuluj w dowolnym momencie',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Płatność otrzymana. Aktywowanie subskrypcji…',
  kjuup_io_toast_activating_soon: 'Płatność otrzymana. Subskrypcja wkrótce zostanie aktywowana.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'Pozostało {count} godz.',
  kjuup_io_trial_left_hour: 'Pozostała 1 godzina',
  kjuup_io_trial_left_minutes: 'Pozostało {count} min',
  kjuup_io_trial_left_minute: 'Pozostała 1 minuta',
  kjuup_io_trial_left_seconds: 'Pozostało {count} s',
  kjuup_io_trial_left_second: 'Pozostała 1 sekunda',
  kjuup_io_trial_ending_now: 'Okres próbny się kończy…',
  kjuup_io_request_timeout: 'Przekroczono limit czasu połączenia. Spróbuj ponownie.',
  kjuup_io_info_days_free: '{days} dni całkowicie za darmo – subskrypcja zaczyna się dopiero po okresie próbnym.',
  kjuup_io_discount_total: 'Twój rabat: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'Osobisty: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Zamknij',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Twój bezpłatny okres próbny dobiegł końca',
  kjuup_io_trial_ended_body: 'Wykup subskrypcję Kjuup.io, aby dalej korzystać z e-maila i innych funkcji premium.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Twój bezpłatny okres próbny się rozpoczął',
  kjuup_io_toast_trial_fail: 'Nie udało się rozpocząć okresu próbnego',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / miesiąc',
  kjuup_io_save_amount_year: 'Oszczędzasz {price} rocznie',
  kjuup_io_billed_annually_amount: '{price} rozliczane rocznie',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Co otrzymujesz:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Karta kredytowa nie jest wymagana – zacznij od razu, bez danych płatniczych.',
  kjuup_io_info_cancel_anytime: 'Anuluj w dowolnym momencie – bez zobowiązań, bez ryzyka.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Okres rozliczeniowy',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Metoda płatności zapisana. Opłata zostanie pobrana po zakończeniu okresu próbnego.',
  calendar_sync_info: 'Automatycznie synchronizuj wszystkie zadania ToDo Kjuup z kalendarzem.',
  calendar_no_accounts: 'Nie połączono jeszcze kalendarza.',
  article_new_badge: 'NOWE',
  article_new_posts: '{0} nowych postów',
  documents: 'Dokumenty',
  add_documents: 'Dodaj dokumenty',
  no_preview_available: 'Podgląd niedostępny',
  no_preview_hint: 'Tego typu pliku nie można wyświetlić w podglądzie, ale i tak zostanie wysłany.',
  max_documents_reached: 'Możesz dołączyć maksymalnie 10 dokumentów jednocześnie.',
  open_file: 'Otwórz plik',
  twofa_title: 'Uwierzytelnianie dwuskładnikowe',
  twofa_method_totp: 'Aplikacja uwierzytelniająca',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-mail',
  twofa_enter_app: 'Wpisz 6-cyfrowy kod z aplikacji uwierzytelniającej.',
  twofa_enter_sms: 'Wpisz 6-cyfrowy kod z SMS-a.',
  twofa_enter_email: 'Wpisz 6-cyfrowy kod z e-maila.',
  twofa_resend: 'Wyślij kod ponownie',
  twofa_try_another: 'Inna metoda',
  twofa_remember_device: 'Nie pytaj na tym urządzeniu przez 30 dni',
  twofa_sent: 'Wysłaliśmy kod.',
  twofa_invalid_code: 'Ten kod jest nieprawidłowy. Spróbuj ponownie.',
  twofa_something_wrong: 'Coś poszło nie tak. Spróbuj ponownie.',
  twofa_method_unavailable: 'Ta metoda jest niedostępna.',
  twofa_on_desc: 'Uwierzytelnianie dwuskładnikowe jest włączone. Przy każdym logowaniu potrzebny będzie kod.',
  twofa_off_desc: 'Dodaj drugi krok po haśle. Aplikacje uwierzytelniające są najbezpieczniejsze.',
  twofa_methods: 'Metody',
  twofa_on: 'Włączone',
  twofa_add: 'Dodaj',
  twofa_default_method: 'Domyślna metoda',
  twofa_default: 'Domyślna',
  twofa_turn_off: 'Wyłącz',
  twofa_disable_hint: 'Wpisz hasło i aktualny kod, aby wyłączyć uwierzytelnianie dwuskładnikowe.',
  twofa_disable_need: 'Wpisz hasło i kod weryfikacyjny.',
  twofa_code_placeholder: '6-cyfrowy kod lub kod zapasowy',
  twofa_send_code: 'Wyślij kod',
  twofa_primary_updated: 'Domyślna metoda została zaktualizowana.',
  twofa_disabled: 'Uwierzytelnianie dwuskładnikowe jest wyłączone.',
  twofa_enabled: 'Uwierzytelnianie dwuskładnikowe jest włączone.',
  twofa_totp_help: 'Zeskanuj ten kod QR w Google Authenticator, Authy lub 1Password. Klucz możesz też wpisać ręcznie.',
  twofa_secret_copied: 'Skopiowano klucz',
  twofa_sms_help: 'Podaj numer w formacie międzynarodowym. Wyślemy 6-cyfrowy kod SMS-em.',
  twofa_email_help: 'Wyślemy 6-cyfrowy kod na e-mail konta.',
  twofa_backup_title: 'Kody zapasowe',
  twofa_backup_help: 'Zachowaj te jednorazowe kody w bezpiecznym miejscu. Każdy kod działa raz, gdy zgubisz telefon.',
  twofa_copy_codes: 'Kopiuj kody',
  twofa_codes_copied: 'Skopiowano kody zapasowe',
  twofa_regenerate: 'Uzyskaj nowe kody zapasowe',
  twofa_regenerate_hint: 'To zastąpi niewykorzystane kody zapasowe. Wpisz hasło i aktualny kod.',
  twofa_backup_remaining: 'Pozostało {n} niewykorzystanych kodów zapasowych',
  twofa_new_codes: 'Nowe kody zapasowe',
  twofa_sms_unavailable: 'Kody SMS nie są jeszcze dostępne.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Przypisane zadania Kjuup są kopiowane do projektu „Kjuup” w Twoim Todoist. Zmiany w Todoist nie są kopiowane z powrotem.",
  todoist_connect: "Połącz Todoist",
  todoist_connected: "Todoist połączony",
  todoist_connect_failed: "Nie udało się połączyć z Todoist",
  todoist_disconnect: "Odłącz",
  todoist_disconnected: "Todoist odłączony",
  todoist_disconnect_confirm: "Odłączyć Todoist? Zadania już obecne w Todoist zostaną. Synchronizacja się zatrzyma.",
  todoist_sync_now: "Synchronizuj teraz",
  todoist_syncing: "Synchronizowanie…",
  todoist_sync_done: "Synchronizacja zakończona",
  todoist_sync_failed: "Synchronizacja nie powiodła się",
  todoist_auth_error: "Połącz Todoist ponownie, aby kontynuować synchronizację.",
  todoist_last_sync: "Ostatnia synchronizacja",
  todoist_not_connected: "Todoist nie jest połączony",
  todoist_auth_url_failed: "Nie udało się otworzyć strony autoryzacji Todoist.",
  recommend_text: "Dołącz do Kjuup, aby być w kontakcie i mieć porządek w komunikacji. Połącz swoje kanały, trzymaj wiadomości we właściwych projektach i zaczynaj każdy poranek od podsumowania i swoich zadań – wszystko zsynchronizowane z aplikacjami, których już używasz. Zacznij za darmo:",
  pro_auth_signin_title: 'Witaj ponownie',
  pro_auth_signin_sub: 'Zaloguj się służbowym adresem e-mail.',
  pro_auth_email_or_username: 'E-mail lub nazwa użytkownika',
  pro_auth_email_placeholder: 'imie@firma.pl',
  pro_auth_forgot_password: 'Nie pamiętasz hasła?',
  pro_auth_create_account: 'Utwórz konto',
  pro_auth_show_password: 'Pokaż hasło',
  pro_auth_hide_password: 'Ukryj hasło',
  pro_auth_register_sub: 'Wyślemy Ci link do potwierdzenia adresu e-mail.',
  pro_auth_register_plus_sub: 'Wybierz nazwę użytkownika i hasło. Następnie ustawisz swój PIN bezpieczeństwa.',
  pro_auth_check_credentials: 'Sprawdź swój e-mail i hasło',
  pro_news_export_pdf: 'Eksportuj jako PDF',
  pro_news_pdf_failed: 'Nie udało się utworzyć pliku PDF.',
  pro_news_pdf_attachments: 'Załączniki',
  pro_news_pdf_video: 'Wideo',
  pro_auth_forgot_sub: 'Wpisz swój e-mail, a wyślemy Ci link do zresetowania hasła.',
  pro_auth_send_link: 'Wyślij link resetujący',
  pro_auth_plus_reset: 'Zresetuj za pomocą PIN-u',
  pro_auth_show_pin: 'Pokaż PIN',
  pro_auth_hide_pin: 'Ukryj PIN',
  v2_auth_plus_only: 'Tylko Kjuup+',
  room_action_media: "Pliki",
  room_tab_overview: "Przegląd",
  room_tab_history: "Historia",
  chat_info_media: "Pliki",
  messages: "wiadomości",
  pro_todo_project_required: "Wybierz projekt",
  pro_todo_choose_project: "Do którego projektu należy to zadanie?",
  cockpit_report_delete_confirm: "Usunąć ten raport dzienny?",
  cockpit_report_deleted: "Raport dzienny usunięty",
  cockpit_tab_company: "Firma",
  cockpit_bookmarked_priorities: "Zapamiętane zadania",
  cockpit_load_error: "Nie udało się wczytać kokpitu.",
  cockpit_retry: "Spróbuj ponownie",
  cockpit_yesterday: "Wczoraj",
  cockpit_greeting_morning: "Dzień dobry",
  cockpit_greeting_day: "Dzień dobry",
  cockpit_greeting_evening: "Dobry wieczór",
  cockpit_assistant_q_open: "Co jest dziś otwarte?",
  cockpit_assistant_q_summarize: "Podsumuj czat {{room}}",
  cockpit_assistant_q_overdue: "Które zadania są przeterminowane?",
  cockpit_assistant_new: "{{n}} nowych",
  cockpit_assistant_important: "{{n}} ważnych",
  cockpit_assistant_title: "Asystent Kjuup",
  cockpit_assistant_hint: "Dotknij i zapytaj",
  room_overview_priority_no_detail: "Raport nie podaje więcej szczegółów dotyczących tego priorytetu.",
  room_overview_priority_from: "Źródło: {{name}}",
  room_overview_priority_open_task: "Otwórz zadanie",
  cockpit_priority_position: "{{index}} z {{total}} priorytetów",
  room_overview_today_title: "Ważne dziś",
  room_overview_all_tasks: "Wszystkie",
  room_overview_tasks_empty: "Brak otwartych terminów i zadań",
  room_overview_appointments_empty: "Brak nadchodzących spotkań",
  room_overview_no_priorities: "Brak otwartych priorytetów w ostatnim raporcie.",
  cockpit_report_top5: "5 najważniejszych priorytetów",
  cockpit_report_todo_created: "Zadanie utworzone",
  cockpit_report_source_missing: "Nie znaleziono wiadomości źródłowej.",
  delete_bookmarked_priority_confirm: "Czy na pewno chcesz usunąć to zapamiętane zadanie?",
  cockpit_report_create_todo: "Utwórz zadanie",
  cockpit_priorities_deleting: "Usuwanie …",
  cockpit_priorities_select: "Usuń kilka",
  cockpit_report_none: "Brak wpisów.",
  cockpit_priorities_delete_confirm: "Czy na pewno chcesz usunąć zapamiętane zadania ({count})?",
  cockpit_priorities_delete_failed: "Nie udało się usunąć zadań: {count}",
  cockpit_priorities_deleted: "Usunięto zadań: {count}",
  cockpit_priorities_selected: "Zaznaczono: {count}",
  cockpit_channel_connected: "Połączono",
  cockpit_channel_not_connected: "Brak połączenia",
  cockpit_channel_connect: "Połącz",
  cockpit_channel_chat: "Czat Kjuup",
  cockpit_channel_active: "Aktywny",
  cockpit_channel_hidden: "Ukryty",
  cockpit_channel_enable: "Włącz",
  cockpit_channel_email: "E-mail",
  cockpit_channel_check: "Sprawdź połączenie",
  cockpit_channel_fix: "Sprawdź",
  cockpit_channel_forward: "Adres przekierowania",
  cockpit_channel_not_set_up: "Nie skonfigurowano",
  cockpit_channel_set_up: "Skonfiguruj",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Połączenie przerwane",
  cockpit_channel_importing: "Trwa import",
  cockpit_channel_removing: "Rozłączanie",
  cockpit_channel_reconnect: "Połącz ponownie",
  cockpit_channels_title: "Kanały",
  cockpit_company_role_super_admin: "Administrator firmy",
  cockpit_company_role_dept_admin: "Administrator działu",
  cockpit_company_role_member: "Pracownik",
  cockpit_company_none: "Nie znaleziono firmy Kjuup+",
  cockpit_company_eyebrow: "Firma",
  cockpit_company_inactive: "nieaktywna",
  cockpit_company_settings: "Ustawienia firmy",
  cockpit_company_employees: "Pracownicy",
  cockpit_company_internal_rooms: "Projekty wewnętrzne",
  cockpit_report_all_projects: "Wszystkie projekty",
  cockpit_report_progress_emails: "Analiza e-maili",
  cockpit_report_progress_chats: "Analiza wiadomości czatu",
  cockpit_report_progress_documents: "Analiza załączników i dokumentów",
  cockpit_report_progress_tasks: "Analiza zadań",
  cockpit_report_progress_summarizing: "Analiza treści",
  cockpit_report_progress_reading: "Wykorzystywanie wcześniej przeanalizowanych treści",
  cockpit_report_progress_collecting: "Zbieranie e-maili, czatów i zadań z Twoich projektów",
  cockpit_report_progress_priorities: "Zestawianie priorytetów, terminów i decyzji",
  cockpit_report_progress_queued: "Przygotowywanie raportu",
  cockpit_report_creating_title: "Twój raport dzienny jest w trakcie tworzenia",
  cockpit_report_progress_count_one: "Przeanalizowano 1 element",
  cockpit_report_progress_count_many: "Przeanalizowano elementów: {{count}}",
  cockpit_report_progress_hint: "Zwykle trwa to od jednej do dwóch minut – w tym czasie możesz dalej korzystać z kokpitu.",
  cockpit_report_time_hint: "Raport dzienny jest tworzony codziennie o {{hour}}:00 dla pięciu najaktywniejszych projektów.",
  room_overview_priorities_title: "Aktualny status i priorytety",
  room_overview_as_of: "Stan na: {{time}}",
  cockpit_report_delete: "Usuń raport dzienny",
  email_tag_daily_briefing: "Raport dzienny",
  cockpit_report_unread: "Nowy",
  cockpit_report_clear_project: "Pokaż wszystkie projekty",
  cockpit_filter_project: "Projekt",
  cockpit_filter_all_projects: "Wszystkie projekty",
  cockpit_report_recreate: "Utwórz raport dzienny ponownie",
  cockpit_report_hide_previous: "Ukryj poprzednie raporty dzienne",
  cockpit_report_show_previous: "Pokaż poprzednie raporty dzienne",
  cockpit_report_room_empty: "Brak raportu dziennego dla tego projektu",
  cockpit_report_empty: "Brak raportu dziennego",
  cockpit_report_room_empty_hint: "Utwórz raport dzienny tylko dla tego projektu.",
  cockpit_report_needs_mailbox: "Połącz konto e-mail, aby Kjuup mógł tworzyć raport dzienny z automatycznymi zadaniami.",
  cockpit_report_create: "Utwórz raport dzienny",
  cockpit_email_connect: "Połącz e-mail",
  cockpit_email_none_title: "Brak połączonego konta e-mail",
  cockpit_email_none_reports: "Połącz swoją skrzynkę, aby Kjuup przypisywał przychodzące e-maile do Twoich projektów i tworzył z nich raporty dzienne z zadaniami.",
  cockpit_email_none_client: "Połącz Gmail, Outlook lub IMAP, aby czytać, przypisywać i odpowiadać na e-maile bezpośrednio w Kjuup.io.",
  cockpit_email_reports_title: "Dotychczasowy klient poczty",
  cockpit_email_reports_text: "Brak skrzynki w Kjuup.io · projekty z raportem dziennym o {{hour}}:00: {{rooms}} · przychodzące e-maile są przypisywane do Twoich projektów.",
  cockpit_email_reports_rooms: "Zarządzaj projektami",
  cockpit_email_settings: "Ustawienia e-mail",
  cockpit_email_error_title: "Sprawdź połączenie",
  cockpit_email_client_title: "Odbiór skonfigurowany",
  cockpit_email_accounts_n: "Połączone konta: {{n}}",
  cockpit_email_last_sync: "ostatnie pobranie {{when}}",
  cockpit_email_report_at: "Raport dzienny o {{hour}}:00",
  cockpit_email_open_inbox: "Otwórz skrzynkę",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Połączone adresy e-mail",
  email_folder_sent: "Elementy wysłane",
  email_no_subject: "(Bez tematu)",
  cockpit_email_detail_loading: "Wczytywanie e-maila …",
  cockpit_email_detail_failed: "Nie udało się wczytać e-maila.",
  cockpit_email_detail_empty: "Ten e-mail nie zawiera tekstu.",
  cockpit_personal_settings: "Ustawienia osobiste",
  cockpit_companies: "Firmy",
  cockpit_title: "Kokpit",
  cockpit_back: "Wróć do przeglądu",
  cockpit_day_overview: "Twój dzień w skrócie",
  email_saved_to_project: "E-mail zapisany w projekcie",
  email_classify_need_project: "Wpisz nazwę projektu",
  cockpit_email_deleted: "E-mail usunięty",
  cockpit_email_sent_empty: "Brak wysłanych e-maili.",
  cockpit_email_incoming_empty: "Brak przychodzących e-maili.",
  cockpit_email_incoming_title: "E-maile",
  cockpit_email_incoming_sub: "Przypisz przychodzące i wysłane e-maile do swoich projektów. Przypisanie możesz tutaj zmienić.",
  cockpit_email_incoming_unassigned_n: "Nieprzypisane: {{n}}",
  cockpit_email_folder_inbox: "Odebrane",
  cockpit_email_folder_sent: "Wysłane",
  cockpit_email_open: "Otwórz e-mail",
  cockpit_email_incoming_suggested: "Propozycja: {{room}}",
  cockpit_email_incoming_apply: "Zastosuj",
  cockpit_email_incoming_adjust: "Zmień przypisanie",
  cockpit_email_incoming_saving: "Zapisywanie …",
  cockpit_email_incoming_unassigned: "Nieprzypisano",
  cockpit_email_incoming_show_less: "Pokaż mniej",
  cockpit_email_incoming_show_all: "Pokaż wszystkie ({{n}})",
  cockpit_io_settings: "Ustawienia Kjuup.io",
  cockpit_io_settings_sub: "Plan i licencje, przypisanie pracowników oraz rozliczenia i faktury.",
  products_coming_soon: "Wkrótce",
  cockpit_upsell_io_title: "Twoje biuro, które myśli razem z Tobą",
  cockpit_upsell_io_text: "Połącz swoje konta e-mail z Kjuup. E-maile, załączniki i wiadomości są automatycznie zapisywane w odpowiednim projekcie i opcjonalnie mogą być przechowywane na Twoim serwerze. Codziennie otrzymujesz podsumowanie wszystkich projektów z najważniejszymi punktami ze wszystkich treści, a Twoje zadania synchronizują się z kalendarzem lub aplikacją do zadań.",
  cockpit_upsell_io_soon_title: "Jeszcze niedostępne",
  cockpit_upsell_io_soon_text: "Kjuup.io wkrótce wystartuje. Poproś o informacje – damy Ci znać, gdy tylko będzie można zamówić Kjuup.io.",
  cockpit_upsell_io_planned_price: "Planowana cena",
  cockpit_upsell_io_cta_request: "Poproś o informacje",
  kjuup_plus_abo_per_year: "/ rok",
  kjuup_plus_abo_per_month: "/ miesiąc",
  kjuup_plus_abo_status_active: "Aktywna",
  kjuup_plus_abo_status_requested: "Wniosek o wypowiedzenie",
  kjuup_plus_abo_status_past_due: "Płatność oczekuje",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Subskrypcja",
  kjuup_plus_abo_title: "Pakiet Kjuup+",
  kjuup_plus_abo_seats_free_one: "Wolne 1 miejsce",
  kjuup_plus_abo_billing: "Sposób płatności",
  kjuup_plus_abo_yearly: "Rocznie",
  kjuup_plus_abo_monthly: "Miesięcznie",
  kjuup_plus_abo_amount: "Kwota",
  kjuup_plus_abo_ends: "Kończy się",
  kjuup_plus_abo_renews: "Następne odnowienie",
  kjuup_plus_abo_next_invoice: "Następna faktura",
  kjuup_plus_abo_intro: "Cena promocyjna",
  kjuup_plus_abo_pending_tier: "Od następnego odnowienia",
  kjuup_plus_abo_manual: "Kjuup+ jest aktywny dla Twojej firmy na podstawie indywidualnej umowy.",
  kjuup_plus_abo_invoices: "Faktury",
  kjuup_plus_abo_invoice_paid: "Opłacona",
  kjuup_plus_abo_invoice_view: "Zobacz",
  kjuup_plus_abo_invoices_less: "Pokaż mniej",
  kjuup_plus_abo_member_hint: "Rozliczeniami i wypowiedzeniem zarządzają administratorzy firmy.",
  kjuup_plus_abo_withdraw: "Wycofaj wniosek",
  kjuup_plus_abo_cancel_note: "Powód (opcjonalnie)",
  kjuup_plus_abo_cancel_send: "Złóż wniosek o wypowiedzenie",
  kjuup_plus_abo_cancel: "Wypowiedz subskrypcję",
  cockpit_upsell_plus_f1: "Zarządzaj aktywnością komunikacyjną wszystkich pracowników",
  cockpit_upsell_plus_f2: "Informuj wybrane grupy użytkowników w firmie",
  cockpit_upsell_plus_f3: "Zapisuj wewnętrzne czaty grupowe",
  cockpit_upsell_plus_when_yearly: "przy płatności rocznej",
  cockpit_upsell_plus_size_small: "1–50 pracowników",
  cockpit_upsell_plus_size_large: "51–200 pracowników",
  cockpit_upsell_plus_title: "Kjuup+ dla firm",
  cockpit_upsell_plus_text: "Zarządzaj pracownikami, uprawnieniami do pisania i komunikacją firmową w jednym miejscu. Kanały wewnętrzne pozostają w Twoim zespole, kanały zewnętrzne łączą Cię z partnerami projektowymi, a wybrane grupy możesz informować bezpośrednio. Oprócz Kjuup+ możesz zamówić dostęp Kjuup.io dla grup pracowników. Kjuup+ i Kjuup.io można łączyć.",
  cockpit_upsell_plus_size: "Wielkość firmy",
  cockpit_upsell_plus_billing: "Sposób płatności",
  cockpit_upsell_plus_per_company: "/ firma · miesiąc plus VAT",
  cockpit_upsell_plus_onboarding: "Koszty wdrożenia zależą od wielkości firmy",
  cockpit_upsell_plus_larger: "Ceny dla większych firm na zapytanie",
  cockpit_upsell_plus_cta: "Zapytaj bez zobowiązań",
  cockpit_kpi_deadlines_tasks: "Terminy i zadania",
  cockpit_kpi_appointments: "Spotkania",
  cockpit_room_admin: "Zarządzanie projektami i czatami",
  cockpit_room_admin_sub: "Wszystkie projekty firmy z członkami, mediami i czatami.",
  pro_todo_not_found: "To zadanie nie jest już dostępne.",
  cockpit_chip_overdue: "Przeterminowane",
  cockpit_chip_today: "Dzisiaj",
  cockpit_calendar_week: "Tydz. {{week}}",
  cockpit_prev_week: "Poprzedni tydzień",
  cockpit_next_week: "Następny tydzień",
  cockpit_chip_requested: "Zażądane",
  cockpit_todo_due: "Termin {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "od {{name}}",
  cockpit_todo_since: "od {{when}}",
  cockpit_todo_no_date: "Bez daty",
  cockpit_todo_mark_done: "Oznacz jako wykonane",
  cockpit_my_tasks_title: "Moje zadania",
  cockpit_today_tasks_group: "Zadania na dziś",
  cockpit_assign_none: "Nikt nie jest przypisany",
  no_project_found: "Nie znaleziono projektu",
  cockpit_row_more_actions: "Więcej działań",
  needs_date: "Przypisz termin",
  cockpit_assign_proposal: "Rozpoznano {{name}} – przypisać?",
  cockpit_assign_proposal_confirm: "Przypisz",
  cockpit_assign_proposal_dismiss: "Ignoruj",
  cockpit_priority_date: "Data",
  todo_calendar_add: "Dodaj do kalendarza",
  todo_calendar_remove: "Usuń z kalendarza",
  cockpit_todo_change_project: "Zmień projekt",
  cockpit_todo_set_date: "Ustaw datę",
  pro_todo_done_confirm: "Czy na pewno chcesz oznaczyć to zadanie jako wykonane?",
  cockpit_task_delete_failed: "Nie udało się usunąć zadania.",
  cockpit_setup_title: "Dokończ konfigurację",
  cockpit_setup_text: "Zdecyduj, czy chcesz korzystać z czatów oraz czy Kjuup.io ma działać jako klient poczty, czy tylko z projektami i raportami dziennymi.",
  cockpit_setup_cta: "Skonfiguruj teraz",
  cockpit_group_tasks: "Terminy i zadania",
  cockpit_group_appointments: "Spotkania",
  cockpit_report_no_activity: "W tym projekcie w ciągu ostatnich 24 godzin nie było nowych wiadomości ani e-maili.",
  cockpit_report_room_unavailable: "Ten projekt jest niedostępny.",
  cockpit_report_create_failed: "Nie udało się utworzyć raportu dziennego.",
  cockpit_report_created: "Raport dzienny utworzony",
  addon_enable_confirm: "Włączyć dodatek?",
  addon_enable: "Włącz",
  addon_enabled: "Dodatek włączony",
  nav_email: "E-mail",
  nav_my_cockpit: "Mój kokpit",
  nav_news: "Aktualności",
  nav_recommend: "Poleć",
  pro_todo_status_done: "Wykonane",
  pro_todo_status_open: "Otwarte",
  v2_todo_remove: "Usuń",
  pro_todo_search_people: "Szukaj osób",
  pro_todo_clear: "Wyczyść",
  pro_todo_assigned: "(przypisano)",
  pro_todo_no_people: "Nie znaleziono osób",
  pro_todo_search_rooms: "Szukaj projektów",
  pro_todo_no_rooms_match: "Brak projektów dla „{{q}}”",
  pro_todo_no_rooms: "Nie znaleziono projektów",
  pro_todo_activity: "Aktywność",
  pro_todo_show_less: "Pokaż mniej",
  pro_todo_show_all: "Pokaż wszystkie ({{n}})",
  pro_todo_due: "Termin",
  pro_todo_room: "Projekt",
  pro_todo_select_room: "Wybierz projekt",
  pro_todo_status: "Status",
  pro_todo_more: "Więcej",
  pro_todo_edit_title: "Edytuj zadanie",
  pro_todo_description: "Opis",
  pro_todo_created_by: "Utworzone przez",
  pro_todo_chat: "Czat",
  navigate_to_source: "Przejdź do źródła",
  todo_calendar_connect_title: "Brak połączonego kalendarza",
  todo_calendar_connect_body_web: "Połącz kalendarz w ustawieniach synchronizacji kalendarza, aby dodawać do niego zadania.",
  todo_calendar_connect: "Połącz",
  todo_calendar_removed: "Usunięto z Twojego kalendarza",
  todo_calendar_added_later: "Dodano. Nie udało się połączyć z kalendarzem; Kjuup spróbuje ponownie później.",
  todo_calendar_added: "Dodano do Twojego kalendarza",
  todo_calendar_no_date: "Do kalendarza można dodać tylko zadanie z datą.",
  todo_calendar_failed: "Nie udało się zaktualizować kalendarza. Spróbuj ponownie.",
  todo_calendar_date_title: "Brak daty",
  todo_calendar_date_save: "Ustaw datę i dodaj",
  todo_calendar_date_body_web: "To zapamiętane zadanie nie ma jeszcze daty. Ustaw ją, aby dodać zadanie do kalendarza.",
  kjuup_io_setup_saved: "Konfiguracja zapisana",
  kjuup_io_setup_step: "Krok",
  kjuup_io_setup_chats_title: "Czy chcesz korzystać z czatów?",
  kjuup_io_setup_email_title: "Gdzie chcesz czytać swoje e-maile?",
  kjuup_io_setup_chats_sub: "Czaty ze współpracownikami i partnerami projektowymi są opcjonalne. W kokpicie możesz je w każdej chwili pokazać lub ukryć.",
  kjuup_io_setup_email_sub: "Tutaj wybierasz tylko, czy korzystasz z klienta poczty w Kjuup, czy nadal z dotychczasowego programu, na przykład Outlooka lub innego. Możesz zmienić to później.",
  kjuup_io_setup_chats_yes: "Tak, pokaż czaty",
  kjuup_io_setup_chats_yes_text: "Wiadomości zawierają czaty i e-maile. Projekty mają czaty grupowe dla wszystkich uczestników.",
  kjuup_io_setup_chats_no: "Nie, pracuj bez czatów",
  kjuup_io_setup_chats_no_text: "Czaty są ukryte. „Wiadomości” zmieniają się w „E-mail”; projekty, zadania i raporty dzienne pozostają.",
  kjuup_io_setup_email_client: "Klient poczty w Kjuup",
  kjuup_io_setup_email_client_text: "Czytaj e-maile i odpowiadaj na nie bezpośrednio w Kjuup.",
  kjuup_io_setup_email_reports: "Dotychczasowy klient poczty",
  kjuup_io_setup_email_reports_text: "Nadal czytaj e-maile i odpowiadaj na nie w obecnym programie, na przykład Outlooku lub innym.",
  kjuup_io_setup_skip: "Później",
  next: "Dalej",
  kjuup_io_setup_finish: "Dokończ konfigurację",
  today_label: "dziś",
  tomorrow_label: "jutro",
  cockpit_todo_overdue: "przeterminowane",
  cockpit_report_management_fazit: "Podsumowanie dla zarządu",
  cockpit_todo_appointment: "Spotkanie",
  cockpit_todo_deadline: "Termin",
  cockpit_todo_deadline_define: "Ustal termin",
  pro_todo_status_acknowledged: "Potwierdzone",
  pro_todo_responsible: "Odpowiedzialny",
  pro_todo_notice_confirmed: "Potwierdzono na czacie",
  pro_todo_notice_sent_at: "Wiadomość wysłana",
  pro_todo_notice_again: "Wyślij wiadomość ponownie",
  pro_todo_notice_send: "Powiadom wiadomością Kjuup",
  pro_todo_add_assignee: "Dodaj",
  pro_todo_edit: "Edytuj",
  pro_todo_change_room: "Zmień projekt",
  pro_todo_due_on: "Termin do",
  pro_todo_edit_due: "Edytuj termin",
  pro_todo_no_date: "Bez daty",
  pro_todo_edit_description: "Edytuj opis",
  pro_todo_no_description: "Brak opisu",
  pro_todo_title_label: "Tytuł",
  pro_todo_title_placeholder: "Wpisz tytuł...",
  pro_todo_task: "Zadanie",
  pro_todo_what: "Co trzeba zrobić?",
  pro_todo_source_email: "E-mail",
  pro_todo_sources: "Źródła",
  previous: "Poprzednie",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (do {max} pracowników)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (do {max} pracowników)",
  kjuup_plus_abo_status_ends: "Kończy się {date}",
  kjuup_plus_abo_seats_over: "Ponad {max} pracowników – Kjuup skontaktuje się z Tobą z indywidualną ofertą.",
  kjuup_plus_abo_seats_next: "Gdy dołączy więcej pracowników, pakiet automatycznie zmieni się na {next} (rozliczenie proporcjonalne).",
  kjuup_plus_abo_seats_used: "Zajęte miejsca: {used} z {total}",
  kjuup_plus_abo_seats_free: "Wolne miejsca: {count}",
  kjuup_plus_abo_intro_until: "do {date}",
  kjuup_plus_abo_invoice_open: "Otwarta · termin płatności {date}",
  kjuup_plus_abo_invoices_all: "Pokaż wszystkie ({count})",
  kjuup_plus_abo_requested_hint: "Wypowiedzenie zgłoszone {date}. Kjuup potwierdzi je na koniec okresu umowy ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup sprawdzi Twój wniosek i potwierdzi wypowiedzenie na koniec okresu umowy ({end}). Do tego czasu Kjuup+ pozostaje aktywny.",
  kjuup_plus_abo_withdrawn: "Wniosek o wypowiedzenie wycofany",
  kjuup_plus_abo_requested: "Wypowiedzenie zgłoszone",
  cockpit_upsell_plus_intro_hint: "pierwsze {months} miesiące, potem {price}",
  cockpit_upsell_plus_badge: "CENA WPROWADZAJĄCA NA {months} MIESIĄCE",
  calendar_syncing: "Aktualizowanie z kalendarza…",
  calendar_sync_up_to_date: "Kalendarz jest aktualny",
  calendar_sync_failed: "Synchronizacja nie powiodła się",
  delete_multiple_tasks_confirm: "Czy na pewno chcesz usunąć {count} ToDo?",
  todos_deleted_count: "Usunięto {count} ToDo",
  todos_deleted_partial: "Usunięto {ok} ToDo, {fail} nieudanych",
  todo_unknown: "Nieznany",
  todo_created_from_message: "Zadanie utworzone z tej wiadomości",
  kjuup_io_todo_calendar_trial_ended_note: "Synchronizacja kalendarza · Subskrybuj",
  kjuup_io_todo_calendar_nudge: "Zsynchronizować to ToDo z kalendarzem?",
  kjuup_io_todo_calendar_nudge_cta: "Aktywuj Kjuup.io",
  todo_confirmed: "ToDo potwierdzone",
  pro_todo_bulk_delete_title: "Usunąć zadania ({{n}})?",
  pro_todo_previous_none_own: "Zaległe zadania zostały Ci przydzielone przez innych i tylko oni mogą je usunąć.",
  pro_todo_previous_none: "Brak zaległych zadań",
  pro_todo_previous_title: "Usunąć zaległe zadania ({{n}})?",
  pro_todo_previous_text: "Wszystkie Twoje otwarte zadania z poprzednich dni zostaną usunięte.",
  pro_todo_previous_skipped: "Zadania przydzielone przez innych pozostają: {{n}}.",
  unassign_task_confirm: "Czy chcesz cofnąć swoje przypisanie do tego zadania?",
  unassign_label: "Cofnij",
  pro_todo_delete_title: "Usuń zadanie",
  pro_todo_today: "Dzisiaj",
  pro_todo_yesterday: "Wczoraj",
  pro_todo_since_yesterday: "Od wczoraj",
  pro_todo_mark_open: "Oznacz jako otwarte",
  verify_completion: "Zweryfikuj",
  new_label: "Nowe",
  bookmarked_no_mylist: "Zadań w zakładkach nie można dodać do Mojej listy",
  delete_only_own: "Możesz usuwać tylko zadania, które sam utworzyłeś",
  todo_clear_all: "Wyczyść wszystko",
  pro_todo_of_completed: "Ukończono {{done}} z {{total}}",
  pro_todo_pick_date: "Wybierz datę",
  pro_todo_show_day: "Pokaż dzień",
  pro_todo_section_upcoming: "Nadchodzące",
  pro_todo_section_done: "Wykonane",
  pro_todo_room_empty_today: "Brak zadań na dziś w tym projekcie",
  pro_todo_room_empty_day: "Brak zadań w tym dniu w tym projekcie",
  pro_todo_delete_previous: "Usuń wszystkie",
  pro_todo_empty_title: "Nic tu nie ma",
  pro_todo_empty_hint: "Brak zadań pasujących do tego widoku.",
  pro_todo_selected: "Zaznaczono: {{n}}",
  delete_selected_count: "Usuń ({count})",
  pro_todo_adjust_done: "Gotowe",
  pro_todo_deleting: "Usuwanie...",
  pro_todo_reopen: "Otwórz zadanie ponownie",
  pro_todo_step_done: "Wykonane",
  move_back_in_progress: "Wróć do realizacji",
  pro_todo_mark_not_started: "Oznacz jako nierozpoczęte",
  back_into_in_progress: "Wróć do realizacji",
  pro_todo_mark_in_progress: "Oznacz jako w toku",
  unassign_todo: "Cofnij przypisanie ToDo",
  pro_todo_open_room: "Otwórz projekt",
  pro_todo_new_task: "Nowe zadanie",
  select_user_back_to_in_progress: "Wybierz użytkownika, który ma wrócić do realizacji",
  cockpit_email_accounts_n_many: "Połączone konta: {{n}}",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kontakty Kjuup",
  combined_tab_teams: "Kontakty Teams",
  combined_bridge_failed: "Nie udało się utworzyć kopii w Teams.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kontakty Kjuup i Teams: zostanie utworzona nowa grupa, widoczna także w Microsoft Teams.",
  teams_new_chat_title: "Nowy czat Teams",
  teams_new_chat_topic: "Nazwa grupy (opcjonalnie)",
  teams_new_chat_start: "Rozpocznij czat",
  teams_new_chat_creating: "Tworzenie czatu…",
  teams_new_chat_forbidden: "Microsoft Teams nie zezwala na ten czat (np. osoba spoza Twojej organizacji lub zasada Twojego działu IT).",
  teams_new_chat_too_many: "Za dużo osób na jeden czat.",
  teams_new_chat_type_hint: "Wpisz imię, aby wyszukać w swojej organizacji.",
  teams_new_chat_directory_forbidden: "Twoja organizacja nie zezwala na wyszukiwanie w katalogu. Wyświetlane są tylko osoby z Twoich czatów Teams.",
  teams_new_chat_account: "Konto",
};
